import React from 'react';
import { apiManage_rbp } from '../../../request';
import GlobalNotification from '../../../component/common/snackbar';
import i18n from '../../../i18n';
import { Box, Button, Grid } from '@mui/material';
import CommonInput from '../../../component/form/common-input.component';
import _ from 'lodash';
import { MUIDataTableColumnDef } from 'mui-datatables';
import ButtonComponent from '../../../component/button/button.component';
import Table from '../../../component/table/table';
import DialogComponent from '../../../component/dialog/dialog.component';
import Card from '../Card';
import setLoading from '../../../component/linear-determinate';
import DeleteDialogComponent from '../../../component/dialog/delete-dialog.component';
import { ItemUnit } from '../../../models';


/**
 * 规格设置组件
 */
class PriceSpecificationComponent extends React.Component<Props, State> {
    public state: Readonly<State> = {
        // 数据
        data: [],
        // 删除确认框
        deleteOpen: false,
        // 当前选中的要删除的项目
        deleteDataIds: [],
        // 加载中 初次加载时候使用
        isLoading: true,
        // 新增数据最好的id
        bestId: 1,
        // 空时是否校验规则
        isEmpty: 0,
        // 数据详情
        detail: undefined,
        // 当前页
        currPage: 0,
        // 表格每页行数
        rowsPerPage: 20,
        // 当前选中的菜品item
        rowsSelected: []
    }
    // *********************
    // Life Cycle Function
    // *********************
    constructor(props: Props) {
        super(props);
        this.getData = this.getData.bind(this);
    }
    async componentDidMount() {
        await this.init()
        this.setState({
            isLoading: false
        })
    }
    // *********************
    // Default Function
    // *********************
    /**
     * 初始化
     */
    async init() {
        setLoading(true);
        await this.getData();
        setLoading(false);
    }

    /**
     * 获取数据
     * @param detailId number 返回指定的详情数据
     */
    async getData() {
        const result = await apiManage_rbp.getPriceSpecification()
        // 请求成功
        if (!_.get(result, 'error') && result) {
            this.setState({
                data: result,
            })
        }
    }

    // 删除数据
    async handleDeleteData() {
        try {
            const { deleteDataIds } = this.state;
            const result = await apiManage_rbp.delBatchPriceSpecification(deleteDataIds);
            if (!result.error) {
                await this.getData();
                // 清空勾选状态
                this.setState({
                    rowsSelected: []
                })
                GlobalNotification.success(i18n.t('global_text_operate_success'));
            } else {
                GlobalNotification.success(i18n.t('global_text_operate_failure'));
            }
        }
        catch (error) {
            GlobalNotification.success(i18n.t('global_text_operate_failure'));
        }
    }

    dialogConfig(action: 'CONTENT' | 'TITLE' | 'FUN' = 'TITLE') {
        const { detail, isEmpty } = this.state;
        let content: React.ReactNode;
        // let fun: () => Promise<void> = async () => { };
        let title = '';
        switch (detail?.dialogType) {
            case 'ADD':
            case 'EDIT':
                if (action === 'CONTENT') {
                    content = (
                        <Grid>
                            <CommonInput
                                variant={'outlined'}
                                label={i18n.t('standard_set_page_specification_name')}
                                regularType={'required'}
                                value={detail.unitName}
                                style={{ width: '100%' }}
                                isEmpty={Boolean(isEmpty)}
                                onChange={(e) => {
                                    const newDetail = detail;
                                    _.set(newDetail, 'unitName', e.target.value);
                                    this.setState({ detail: newDetail });
                                }}
                            />
                        </Grid >
                    )
                } else if (action === 'TITLE') {
                    title = i18n.t('standard_set_page_price_specification');
                }
                // else {
                //     fun = async () => {
                //         this.handleLabel(detail.dialogType === 'ADD');
                //     };
                // }
                break;
        }
        if (action === 'CONTENT') {
            return content;
        } else if (action === 'TITLE') {
            return title;
        }
        // else if (action === 'FUN') {
        //     return fun;
        // }
    }
    /**
     * 新增、编辑
     */
    async handleLabel(isAdd: boolean) {
        const detail = _.cloneDeep(this.state.detail);
        if (!detail?.unitName.trim()) {
            this.setState({ isEmpty: 1 });
            return
        }
        console.log(detail);
        if (isAdd) {
            const res = await apiManage_rbp.postPriceSpecification({ unit_name: detail?.unitName });
            if (!res?.error) {
                GlobalNotification.success(i18n.t('google_text_add_succeed'));
            } else {
                GlobalNotification.error(i18n.t('google_text_add_failed'));
            }
        } else {
            const res = await apiManage_rbp.patchPriceSpecification(detail?.id, detail?.unitName);
            if (!res?.error) {
                GlobalNotification.success(i18n.t('google_text_edit_succeed'));
            } else {
                GlobalNotification.error(i18n.t('google_text_edit_failed'));
            }
        }
        this.setState({ detail: undefined });
        this.getData();
    }

    /**
     * 选中项，表格头部工具栏显示
     * @returns
     */
    public handleTableToolbarSelectRender(
        selectedRows: { data: Array<{ index: number; dataIndex: number }>; lookup: { [key: number]: boolean } }
    ): React.ReactNode {
        // 选中的数据
        const dishSelected = selectedRows.data.map((item) => (_.get(this.state.data, `[${item.dataIndex}].unit_id`, 0)));
        return (
            <Box padding={'4px 12px'}>
                <ButtonComponent
                    action='DELETE'
                    handleClick={() => {
                        this.setState({
                            deleteOpen: true,
                            deleteDataIds: dishSelected
                        })
                    }}
                />
            </Box>
        )
    }

    // *********************
    // View
    // *********************

    render() {
        const { data, deleteOpen, isLoading, detail, rowsPerPage, rowsSelected } = this.state;
        // 列
        const columns: MUIDataTableColumnDef[] = [
            {
                name: 'unit_id',
                label: 'id',
                options: {
                    sort: true,
                }
            },
            {
                name: 'unit_name',
                label: i18n.t('global_text_name'),
                options: {
                    sort: true,
                }
            }
        ]
        return (
            <Box className='price-specification-page'>
                <Card
                    className='card-content'
                    title={(
                        <Box>
                        </Box>
                    )}
                    actionRender={(
                        <ButtonComponent
                            titleText={i18n.t('google_text_newly_increased')}
                            action='ADD'
                            handleClick={() => {
                                this.setState({
                                    detail: {
                                        dialogType: 'ADD',
                                        unitName: ''
                                    },
                                    isEmpty: 0
                                })
                            }}
                        />
                    )}
                    contentRender={(
                        <Box hidden={isLoading}>
                            <Table
                                data={data}
                                columns={columns}
                                rowsSelected={rowsSelected}
                                onRowSelectionChange={(currentRowsSelected: any[], allRowsSelected: any[], rowsSelected?: number[]) => {
                                    this.setState({
                                        rowsSelected: rowsSelected || []
                                    })
                                }}
                                otherOption={{
                                    viewColumns: true,
                                    search: true,
                                    pagination: true,
                                    page: this.state.currPage,
                                    rowsPerPage,
                                    onChangeRowsPerPage: (nums: number) => {
                                        this.setState({
                                            rowsPerPage: nums,
                                        })
                                    },
                                    onChangePage: (page: number) => {
                                        this.setState({ currPage: page })
                                    },
                                    selectableRowsHeader: true,
                                    selectableRowsHideCheckboxes: false,
                                    selectToolbarPlacement: 'replace',
                                    customToolbarSelect: (
                                        selectedRows,
                                    ): React.ReactNode => {
                                        return this.handleTableToolbarSelectRender(selectedRows);
                                    },
                                    // onRowsDelete: (rowsDeleted, newTableData) => {
                                    //     this.setState({
                                    //         deleteOpen: true,
                                    //         deleteDataIds: rowsDeleted.data.map((item) => (
                                    //             _.get(data, `[${item.dataIndex}].unit_id`, 0)
                                    //         ))
                                    //     })
                                    // },
                                    onCellClick: (colData, cellMeta: {
                                        colIndex: number;
                                        rowIndex: number;
                                        dataIndex: number;
                                        event: React.MouseEvent<Element, MouseEvent>;
                                    }) => {
                                        const item = _.get(data, `[${cellMeta.dataIndex}]`, {} as { unit_id?: number, unit_name?: string });
                                        this.setState({
                                            detail: {
                                                dialogType: 'EDIT',
                                                unitName: item?.unit_name || '',
                                                id: item?.unit_id
                                            },
                                            isEmpty: 0
                                        })
                                    }
                                }}
                            />
                            {/* 弹窗 */}
                            <DialogComponent
                                open={!!detail}
                                fullWidth={false}
                                onClose={() => { this.setState({ detail: undefined }) }}
                                defaultHeaderProps={{
                                    title: this.dialogConfig('TITLE') as string,
                                    onClose: () => { this.setState({ detail: undefined }) }
                                }}
                                footer={
                                    <div>
                                        <Button
                                            color='primary'
                                            variant='outlined'
                                            onClick={() => {
                                                this.setState({ detail: undefined })
                                            }}
                                        >
                                            {i18n.t('google_text_public_button_cancel')}
                                        </Button>
                                        <Box marginLeft={4} display='inline-block'>
                                            <ButtonComponent
                                                variant='contained'
                                                handleClick={async () => {
                                                    await this.handleLabel(detail.dialogType === 'ADD');
                                                }}
                                            >
                                                {i18n.t('google_text_confirm')}
                                            </ButtonComponent>
                                        </Box>
                                    </div>
                                }
                            >
                                <Grid style={{ padding: '8px 8px' }}>
                                    {this.dialogConfig('CONTENT')}
                                </Grid >
                            </DialogComponent>
                            {
                                deleteOpen &&
                                <DeleteDialogComponent
                                    {...{
                                        title: i18n.t('google_text_public_button_delete'),
                                        open: true,
                                        onCancel: () => {
                                            this.setState({
                                                deleteOpen: false
                                            })
                                        },
                                        onConfirm: async () => {
                                            await this.handleDeleteData()
                                            this.setState({
                                                deleteOpen: false
                                            })
                                        },
                                    }}
                                />
                            }
                        </Box>
                    )}
                />
            </Box>
        )
    }
}

export default PriceSpecificationComponent;

// *********************
// Type
// *********************
type Props = {}
type State = {
    // 数据
    data: ItemUnit[];
    // 删除确认框
    deleteOpen: boolean;
    // 当前选中的要删除的项目
    deleteDataIds: number[];
    // 加载中 初次加载时候使用
    isLoading: boolean;
    // 详情数据
    detail?: any;
    // 新增数据最好的id
    bestId: number;
    isEmpty: number;
    // 当前页
    currPage: number;
    // 表格每页行数
    rowsPerPage: number;
    // 当前选中的菜品item
    rowsSelected: number[];
}